import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { Switch, Route, useHistory } from 'react-router-dom'
import { Footer } from '@campgladiator/cgui-core.organisms.footer'
import { LayoutWithHeaderAndFooter } from './templates/LayoutWithHeaderAndFooter'
import { Login } from './pages/Login'
import { OnDemandWorkouts } from './pages/OnDemandWorkouts'
import { OnDemandWorkoutsDetail } from './pages/OnDemandWorkoutsDetail'
import { TrainerBio } from './pages/TrainerBio'
import { Header } from './common/components/Header'
import { Main } from './common/components/Main'
import { useAppSelector, useAppDispatch } from './redux/store'
import { authSelector, reAuthExternalUser } from './redux/features/Auth/'
import { analytics, analyticsEvent } from './common/utility/analytics'
import * as pendo from '../src/pendo'

const { trackCustomEvent } = analytics
const { SCREEN_CHANGE } = analyticsEvent

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

const RoutesWithHeaderAndFooter = () => {
  const { isLoggedIn, user } = useAppSelector(authSelector)

  useEffect(() => {
    pendo.setUserId(user?.id || 'guest')
  }, [user?.id])

  return (
    <LayoutWithHeaderAndFooter>
      <Header isLoggedIn={isLoggedIn} user={user} />
      <Main>
        <Switch>
          <Route path="/" exact component={OnDemandWorkouts} />
          <Route
            path="/workout/:workoutId"
            exact
            component={OnDemandWorkoutsDetail}
          />
          <Route path="/trainer/:emailPrefix" exact component={TrainerBio} />
        </Switch>
      </Main>
      <Footer />
    </LayoutWithHeaderAndFooter>
  )
}

const App = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const authToken = new URLSearchParams(window.location.search).get(
      'magic_token',
    )
    if (authToken) {
      dispatch(reAuthExternalUser(authToken))
      history.replace('/')
    }
  }, [dispatch, history])

  useEffect(() => {
    trackCustomEvent(SCREEN_CHANGE())
  }, [location])

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path="/login" exact component={Login} />
        <Route component={RoutesWithHeaderAndFooter} />
      </Switch>
    </>
  )
}

export default App
